// Base engine
import { Engine } from 'medisoft.conectordatos.clientjs/src/engine'
// Helpers
import conectores from './conns'
import paths from './paths'
// Clases
import Sesiones from './sources/sesiones'
import Profile from './sources/profiles'
import Keys from './sources/keys'
// Others packages
const q = require('q')

export default class Connector {
  constructor () {
    const source = new Engine({
      connDev: conectores.development,
      connProd: conectores.production,
      uris: paths,
      expireSesionMethod: null
    })
    this.Sesiones = new Sesiones(source, q)
    this.Profile = new Profile(source, q)
    this.Keys = new Keys(source, q)
  }
}
